import Images from '../../../state/stores/Image/images';
import { Body1Reg, Title2 } from '../../../config/designSystem/typography';
import { DropShadowMedium } from '../../DropShadows/DropShadowMedium';
import { FC } from 'react';
import { GradientWithImage } from '../../Cards/GradientWithImage';
import { ResultBar } from './ResultBar';
import { SPACING } from '../../../config/designSystem/Spacing';
import { View } from 'react-native';
import { observer } from 'mobx-react';
import { useAvailableDimensions } from '../../../hooks/ui/useAvailableDimensions';
import { useBreakpointWidth } from '../../../hooks/useBreakpointWidth';
import { useStores } from '../../../hooks/useStores';

export const RecommendationHeaderImage: FC<{height: number, featureId: string}> = observer(({ height, featureId }) => {
  const {width} = useAvailableDimensions();
  const heightOverlapping = 100;
  const rootStore = useStores();
  const labels = rootStore?.language.translate.MOBILE.SURVEY_RESULTS;
  const feature = rootStore?.feature.getFeature(featureId);
  const PADDING_HORIZONTAL = useBreakpointWidth({lg: SPACING['sp-32'],md: SPACING['sp-16'], sm: SPACING['sp-8']});
  const widthPercentage = useBreakpointWidth({lg: 60, md: 70, sm: 90});
  return(
    <>
      <GradientWithImage width={width} height={height} designSystemColor='YELLOW' light={true}
        image={Images.other.recommendation}
        resizeMode='center'>

      </GradientWithImage>
      <View style={{
        marginTop: -heightOverlapping,
        backgroundColor:'white',
        alignSelf:'center',
        width:String(widthPercentage) + '%',
        minWidth: 200,
        borderRadius: SPACING['sp-12']}}>
        <DropShadowMedium>
          <View style={{
            paddingVertical: SPACING['sp-48'],
            paddingHorizontal: PADDING_HORIZONTAL
          }}>
            <View style={{rowGap: SPACING['sp-24']}}>
              <View style={{rowGap: SPACING['sp-32']}}>
                <ResultBar featureId={featureId} />
                <Title2>{feature?.outputSentence} <Title2 color={feature?.color}>{feature?.name}</Title2></Title2>
              </View>
              <View>
                <Body1Reg>{feature?.description}</Body1Reg>
              </View>
            </View>

          </View>
        </DropShadowMedium>
      </View>

    </>
  );
});